// Old Reports QA Sheet — the pre-redesign API surface, served by the separate legacy controller
// (app/report-corrections-legacy → spGetReportCorrectionDataLegacy). The redesigned sheet keeps
// using ReportCorrectionService.
import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/report-corrections-legacy'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function UpdateNote(id, data) {
  return ApiRequest.put(`${BaseRoute}/${id}/note`, data)
}

function UpdateStatus(id, data) {
  return ApiRequest.put(`${BaseRoute}/${id}/status`, data)
}

function ExportSearchResult(payload = {}) {
  return ApiRequest.post(`${BaseRoute}/export`, payload, {
    responseType: 'arraybuffer',
  })
}

const API = {
  ...baseFunctions,
  UpdateNote,
  UpdateStatus,
  ExportSearchResult,
}

export default API
